<template>
  <div>
    <!-- <div class="popup-btn">
      <div @click="handleClose">取消</div>
      <div @click="handleClose">确认</div>
    </div> -->
    <div class="popup">
      <!-- 一级 -->
      <div :class="[twoList.length > 0 ? 'b-r': '']" :style="threeList.length > 0 ? 'width: 33%': '50%'">
        <div :class="[idList[0] === item.id ? 'active' : '']" v-for="(item, index) in dataList" :key="index"
          @click="handleFirst(item)">
          <div v-if="parentType === 3">
            {{item.text}}
          </div>
          <div v-else>
            {{item.tenancyName}} {{item.tenancyName ? '/' : ''}} {{item.text}}
          </div>
        </div>
      </div>
      <!-- 二级 -->
      <div :class="[threeList.length > 0 ? 'b-r': '']" :style="threeList.length > 0 ? 'width: 33%': '50%'">
        <div :class="[idList[1] === level1.id ? 'active' : '']" v-for="(level1, index1) in twoList" :key="index1"
          @click="handleTwo(level1)">
          {{level1.text}}
        </div>
      </div>
      <!-- 三级 -->
      <div>
        <div :class="[idList[2] === level2.id ? 'active' : '']" v-for="(level2, index2) in threeList" :key="index2"
          @click="handleThree(level2)">
          {{level2.text}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: []
    },
    groupItem: {
      type: Object,
      default: {}
    },
    parentType: {
      type: Number,
      default: 2
    },
    deptId: {
      type: Number
    }
  },
  data () {
    return {
      idList: [],
      idNameList: [],
      itemName: '',
      activeItem: {},
      showPopup: true,
      twoList: [],
      threeList: [],
    }
  },
  watch: {
    activeItem (val) {
      this.$emit('getGroupItem', this.activeItem)
      this.$emit('getIdName', this.idNameList)
    },
    parentType (val) {
      this.idList = []
      this.idNameList = []
      this.twoList = []
      this.threeList = []
    },
    deptId (val) {
      this.idList = []
      this.idNameList = []
      this.twoList = []
      this.threeList = []
    }
  },
  created () {
    let isLevel2 = false
    this.activeItem = this.groupItem
    this.dataList.forEach(item => {
      if (item.id === this.activeItem.levelId) {
        this.activeItem = item
      }
    })
    //  三级
    if (this.activeItem.children !== undefined && this.activeItem.children !== null && this.activeItem.children.length > 0) {
      isLevel2 = true
    }
    this.handleFirst(this.activeItem)
    if (isLevel2) {
      this.handleTwo(this.activeItem.children[0])
    }
  },
  methods: {
    handleClose (val) {
      this.showPopup = false
      this.$emit('getShowPopupTree', this.showPopup)
    },
    handleFirst (item) {
      this.activeItem = item
      this.idList = []
      this.$set(this.idList, [0], this.activeItem.id)
      this.idNameList = []
      this.$set(this.idNameList, [0], this.activeItem.text)
      this.twoList = item.children
      this.threeList = []
    },
    handleTwo (item) {
      this.activeItem = {
        ...item,
        levelId: this.idList[0]
      }
      this.$set(this.idList, [1], this.activeItem.id)
      this.$set(this.idNameList, [1], this.activeItem.text)
      this.threeList = item.children
    },
    handleThree (item) {
      this.activeItem = {
        ...item,
        levelId: this.idList[0]
      }
      this.$set(this.idList, [2], this.activeItem.id)
      this.$set(this.idNameList, [2], this.activeItem.text)
    }
  }
}
</script>
<style lang="less" scoped>
.popup {
  padding: 10px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  > div {
    line-height: 20px;
    > div {
      padding: 10px 10px 10px 0;
    }
  }
  .b-r {
    border-right: 1px solid #ebedf0;
    box-shadow: 0 0.05333rem 0.32rem rgb(100 101 102 / 12%);
  }
  .active {
    font-weight: bold;
    color: #3974c4;
  }
}
.popup-btn {
  padding: 15px 10px;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  > div:nth-last-child(1) {
    color: #3974c4;
  }
}
</style>
